import {
  Component,
  OnInit,
  ElementRef,
  Input,
  Inject,
  Renderer2,
} from '@angular/core';
import * as Cesium from 'cesium';
import { MatDialogRef} from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

const cesiumContainer = document.createElement('div');
cesiumContainer.id = 'cesiumGlobeContainer';
document.getElementsByTagName('body')[0].appendChild(cesiumContainer);

@Component({
  selector: 'app-previewgeojson',
  templateUrl: './previewgeojson.component.html',
  styleUrls: ['./previewgeojson.component.scss']
})
export class PreviewGeojsonComponent {
   @Input() target: any = { geoJSON: '', area: 0 };
  mapSnap: any;
  defaultLL: any[] = [82.9739, 25.3176];
  roll: any = 0;
  viewer: any = null;
  scene: any = null;
  longLatStr: string = '';
  latlonOverlay = document.createElement('div');
  cesiumToken: any;
  dataLoading: boolean = true;

  constructor(

    private dialogRef: MatDialogRef<PreviewGeojsonComponent>,
    private el: ElementRef, private renderer: Renderer2,
  ) {
    this.cesiumToken = environment.cesiumAccessToken;
   
  }

  ngOnInit(): void {
    var west = 40.0;
    var south = -20.0;
    var east = 120.0;
    var north = 70.0;

    var rectangle = Cesium.Rectangle.fromDegrees(west, south, east, north);
    Cesium.Ion.defaultAccessToken = this.cesiumToken;
    Cesium.Camera.DEFAULT_VIEW_FACTOR = 0;
    Cesium.Camera.DEFAULT_VIEW_RECTANGLE = rectangle;

    const imageryViewModels: any = [];
    const terrainViewModels: any = [];

    //Bing Maps Aerial
    imageryViewModels.push(
      new Cesium.ProviderViewModel({
        name: 'Bing Maps Aerial',
        iconUrl: Cesium.buildModuleUrl(
          'Widgets/Images/ImageryProviders/bingAerial.png'
        ),
        tooltip: 'Bing Maps Aerial',
        creationFunction: function () {
          return new Cesium.IonImageryProvider({ assetId: 2 });
        },
      })
    );

    //Sentinel data
    imageryViewModels.push(
      new Cesium.ProviderViewModel({
        name: 'Sentinel-2',
        iconUrl: Cesium.buildModuleUrl(
          'Widgets/Images/ImageryProviders/sentinel-2.png'
        ),
        tooltip: 'Sentinel-2 cloudless',
        creationFunction: function () {
          return new Cesium.IonImageryProvider({ assetId: 3954 });
        },
      })
    );

    imageryViewModels.push(
      new Cesium.ProviderViewModel({
        name: 'Bing Maps Road',
        iconUrl: Cesium.buildModuleUrl(
          'Widgets/Images/ImageryProviders/bingRoads.png'
        ),
        tooltip: 'Bing Maps Road',
        creationFunction: function () {
          return new Cesium.IonImageryProvider({ assetId: 4 });
        },
      })
    );
    imageryViewModels.push(
      new Cesium.ProviderViewModel({
        name: 'Blue Marble',
        iconUrl: Cesium.buildModuleUrl(
          'Widgets/Images/ImageryProviders/blueMarble.png'
        ),
        tooltip: 'Blue Marble Next Generation July, 2004 imagery from NASA.',
        creationFunction: function () {
          return new Cesium.IonImageryProvider({ assetId: 3845 });
        },
      })
    );

    imageryViewModels.push(
      new Cesium.ProviderViewModel({
        name: 'OpenStreetMap',
        iconUrl: Cesium.buildModuleUrl(
          'Widgets/Images/ImageryProviders/openStreetMap.png'
        ),
        tooltip: 'Open Street Map.',
        creationFunction: function () {
          return new Cesium.OpenStreetMapImageryProvider({
            url: 'https://a.tile.openstreetmap.org/',
          });
        },
      })
    );
    const worldTerrain = Cesium.createWorldTerrain({ requestWaterMask: false });
    terrainViewModels.push(worldTerrain);
    const viewer = new Cesium.Viewer('cesiumContainer', {
      imageryProviderViewModels: imageryViewModels,
      terrainProviderViewModels: [],
      // terrainProvider: worldTerrain,
      baseLayerPicker: true,
      geocoder: false,
      homeButton: true,
      fullscreenButton: false,
      selectionIndicator: true,
      shouldAnimate: false,
      animation: false,
      timeline: false,
      sceneModePicker: true,
      sceneMode: Cesium.SceneMode.SCENE2D,
    });
    this.viewer = viewer

    this.showLatLon(); 

    var target = this.target;

    this.scene = this.viewer.scene;
    if (!this.scene.pickPositionSupported) {
      window.alert('This browser does not support pickPosition.');
    }

    function zoomToLocation() {
      var entities = viewer.entities;
      var entityArray = entities.values;
      var myEntity = entityArray[0];

      if (myEntity) {
        var entities = viewer.entities;
        var entityArray = entities.values;
        var entity = entityArray[0];
        viewer.flyTo(entity);
      } else {
        var dataSourceCollection = viewer.dataSources;
        var dataSource = dataSourceCollection.get(0);

        if (dataSource) {
          viewer.flyTo(dataSource);
        }
      }
    }
    this.loadGeoJson();

    const homeButton = this.el.nativeElement.querySelector('.cesium-home-button');
           
    if (homeButton) {
      this.renderer.listen(homeButton, 'click', function () {        
        zoomToLocation();
      });
    }
  }


  flyHome() {
    this.viewer.camera.flyHome(2); 
  }

  showLatLon() {
    const viewer = this.viewer;
    const latlonOverlay = this.latlonOverlay;
    const scene = this.viewer.scene;
    const canvas = this.viewer.canvas;
    viewer.container.appendChild(latlonOverlay);
    latlonOverlay.style.position = 'absolute';
    latlonOverlay.style['z-index'] = '10';
    latlonOverlay.style.right = '3px';
    latlonOverlay.style.bottom = '88px';
    latlonOverlay.style.height = '30px';

    latlonOverlay.style.width = 'fit-content';
    latlonOverlay.style['pointer-events'] = 'none';
    latlonOverlay.style.textAlign = 'center';
    latlonOverlay.style.justifyContent = 'center';
    latlonOverlay.style.padding = '5px 4px 0 4px';
    latlonOverlay.style.color = 'rgba(255, 255, 255, 1)';
    latlonOverlay.style.backgroundColor = 'rgba(0, 0, 0, 0.2)';
    let mousePosition;
    const accuracy = 15;
    const handler = new Cesium.ScreenSpaceEventHandler(canvas);

    handler.setInputAction((movement) => {
      mousePosition = movement.endPosition;
      const cartesian = viewer.camera.pickEllipsoid(
        movement.endPosition,
        viewer.scene.globe.ellipsoid
      );
      if (cartesian) {
        const cartographic = Cesium.Cartographic.fromCartesian(cartesian);

        const longString = Cesium.Math.toDegrees(cartographic.longitude).toFixed(accuracy);
        const latString = Cesium.Math.toDegrees(cartographic.latitude).toFixed(accuracy);
        const latitude = parseFloat(latString);
        const longitude = parseFloat(longString);

        const latitudeDMS = convertDecimalToDMS(latitude) + (latitude >= 0 ? 'N' : 'S');
        const longitudeDMS = convertDecimalToDMS(longitude) + (longitude >= 0 ? 'E' : 'W');

        function convertDecimalToDMS(decimal) {
          const degrees = Math.floor(Math.abs(decimal));
          const minutesDecimal = (Math.abs(decimal) - degrees) * 60;
          const minutes = Math.floor(minutesDecimal);
          const seconds = (minutesDecimal - minutes) * 60;
                
          const formattedDegrees = degrees !== 0 ? `${degrees}°` : '';
          const formattedMinutes = minutes !== 0 ? `${minutes}'` : '';
          const formattedSeconds = `${seconds.toFixed(1)}"`;
        
          return `${formattedDegrees}${formattedMinutes}${formattedSeconds}`;
        }

        this.longLatStr = 'Lng: ' + longitudeDMS + ', ' + 'Lat: ' + latitudeDMS;

        latlonOverlay.innerHTML =
          "<div style='padding:0px'>" + this.longLatStr + '</div>';
      } else {
        this.longLatStr = '';
        latlonOverlay.innerHTML = "<div style='padding:0px'>Out of Globe</div>";
        // latlonOverlay.style.display = 'none';
      }
      this.roll = Cesium.Math.toDegrees(this.viewer.camera.heading).toFixed(0);
      if (this.roll > 359.5) this.roll = 0;
      // this.compassOverlay.style.transform = `rotate(${360-this.roll}deg)`;
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
  }

  onKeyPress(e: any, msg: string) {
    if (e.key === 'Enter') {
      this.onNoClick(msg);
    }
  }
  onNoClick(msg: any): void {
    this.dialogRef.close('Done');   
  }
  loadGeoJson() {
    const geoJson = "../../../assets/HydrosatTaskingRegions.geojson";
 this.viewer.dataSources.add(Cesium.GeoJsonDataSource.load(geoJson, {
  strokeWidth: 0, 
  clampToGround: true,
})).then((dataSource) => {
  dataSource.entities.values.forEach((entity) => {
      const color = Cesium.Color.MAROON;
    if (entity.polygon) {
      entity.polygon.material = color;
        entity.polygon.outlineColor = color;
    }
  });
  this.dataLoading = false;

}).catch((error) => {
  console.error('Error loading GeoJSON:', error);
});
  }
           
          
        

  
}
